






import { Component, Prop } from 'vue-property-decorator';
import colors from 'vuetify/src/util/colors';
import Vue from 'vue';

@Component<CPrimaryBtn>({})
export default class CPrimaryBtn extends Vue {
  @Prop({ type: String })
  borderColor: string;

  get btnStyle(): Partial<CSSStyleDeclaration> {
    const border = this.borderColor.split('.');
    return {
      border: `thin solid ${colors[border[0]][border[1]]}!important`,
    };
  }
}
